import { useEffect, useRef, useCallback } from 'react'

const resizeObserverSupported = 'ResizeObserver' in window

export const useResizeObserver = ({ refToObserve, onResize = () => null }) => {
  const resizeObserver = useRef(null)
  const unobserve = useCallback(() => {
    if (resizeObserver.current != null) {
      resizeObserver.current.disconnect()
    }
  }, [])

  useEffect(() => {
    if (resizeObserverSupported) {
      if (resizeObserver.current == null) {
        resizeObserver.current = new ResizeObserver(onResize)
      }

      if (refToObserve.current != null) {
        resizeObserver.current.observe(refToObserve.current)
      }

      return unobserve
    }
  })

  return {
    unobserve,
    notSupported: !resizeObserverSupported,
  }
}
